module.exports = __webpack_public_path__ + "img/img3.f51fe5ba.png";